/* status-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._0jFU0VxpxF%7Bheight%3A9pt%7D%0A._39xV02xpxF%7Bwidth%3A9pt%7D%0A._0jFU0VEbN9%7Bheight%3A14px%7D%0A._39xV02EbN9%7Bwidth%3A14px%7D%0A._0jFU0V2sAl%7Bheight%3A15px%7D%0A._39xV022sAl%7Bwidth%3A15px%7D%0A._0jFU0V70UD%7Bheight%3A18px%7D%0A._39xV0270UD%7Bwidth%3A18px%7D%0A._1OKFqYdnbC%7Binset-inline-end%3A0%7D%0A._2I62gzdnbC%7Binset-block-start%3A0%7D%0A._1OKFqYHZdu%7Binset-inline-end%3A1px%7D%0A._2I62gzHZdu%7Binset-block-start%3A1px%7D%0A._1OKFqYXJux%7Binset-inline-end%3A7px%7D%0A._2I62gzXJux%7Binset-block-start%3A7px%7D%0A._1OKFqYA17z%7Binset-inline-end%3A-1px%7D%0A._2I62gzA17z%7Binset-block-start%3A-1px%7D%0A._1OKFqYVo9d%7Binset-inline-end%3A-4px%7D%0A._2I62gzUNDJ%7Binset-block-start%3A4px%7D%0A._1OKFqY8e2l%7Binset-inline-end%3A-5px%7D%0A._2I62gzvFgp%7Binset-block-start%3A17px%7D");




















import { type FC } from 'react';
import AvatarStatus, { type StatusProps } from '../status';
import { type AppearanceType, type IndicatorSizeType } from '../types';
const styles = {
  root: "_1mT5xdWVPG"
};
const iconSizeMap = {
  small: "_0jFU0VxpxF _39xV02xpxF",
  medium: "_0jFU0VEbN9 _39xV02EbN9",
  large: "_0jFU0V2sAl _39xV022sAl",
  xlarge: "_0jFU0V70UD _39xV0270UD"
};
const circleIconOffsetMap = {
  small: "_1OKFqYdnbC _2I62gzdnbC",
  medium: "_1OKFqYdnbC _2I62gzdnbC",
  large: "_1OKFqYHZdu _2I62gzHZdu",
  xlarge: "_1OKFqYXJux _2I62gzXJux"
};
const squareIconOffsetMap = {
  root: "_1OKFqYdnbC _2I62gzdnbC"
};
const hexagonIconOffsetMap = {
  small: "_1OKFqYA17z _2I62gzA17z",
  medium: "_1OKFqYA17z _2I62gzA17z",
  large: "_1OKFqYVo9d _2I62gzUNDJ",
  xlarge: "_1OKFqY8e2l _2I62gzvFgp"
};
interface StatusWrapperProps extends StatusProps {
  appearance: AppearanceType;
  size: IndicatorSizeType;
  testId?: string;
}

/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */
const StatusWrapper: FC<StatusWrapperProps> = ({
  size,
  status,
  appearance,
  borderColor,
  children,
  testId
}) => {
  return <span aria-hidden="true" data-testid={testId && `${testId}--status`} className={ax([styles.root, iconSizeMap[size], circleIconOffsetMap[size], appearance === 'square' && squareIconOffsetMap.root, appearance === 'hexagon' && hexagonIconOffsetMap[size]])}>
			<AvatarStatus borderColor={borderColor} status={!children ? status : undefined}>
				{children}
			</AvatarStatus>
		</span>;
};
export default StatusWrapper;